import './ProductCategories.css'

const Img1 = 'https://cdn.nudus.app/Images/materiales/aislacion.jpg';
const Img2 = 'https://cdn.nudus.app/Images/materiales/calefaccion.jpg';
const Img3 = 'https://cdn.nudus.app/Images/materiales/chapas.jpg';
const Img4 = 'https://cdn.nudus.app/Images/materiales/ferreteria.png';
const Img5 = 'https://cdn.nudus.app/Images/materiales/maderas.jpeg';
const Img6 = 'https://cdn.nudus.app/Images/materiales/pinturas.webp';
const Img7 = 'https://cdn.nudus.app/Images/materiales/pisos.jpg';
const Img8 = 'https://cdn.nudus.app/Images/materiales/placas.jpg';
const Img9 = 'https://cdn.nudus.app/Images/materiales/revestimiento.jpg';
const Img10 = 'https://cdn.nudus.app/Images/materiales/rurales.jpeg';
const Img11 = 'https://cdn.nudus.app/Images/materiales/steelframing.webp';
const Img12 = 'https://cdn.nudus.app/Images/materiales/yeso.webp';

const categories = [
  { name: "Revestimientos", icon: Img9, href: "/productos/revestimientos" },
  { name: "Steel Framing", icon: Img11, href: "/productos/steel-framing" },
  { name: "Placas", icon: Img8, href: "/productos/placas" },
  { name: "Aislación", icon: Img1, href: "/productos/aislacion" },
  { name: "Articulos Rurales", icon: Img10, href: "/productos/articulos-rurales" },
  { name: "Calefaccion, hornos y parrillas", icon: Img2, href: "/productos/calefaccion" },
  { name: "Chapa de policarbonato y Cincalum", icon: Img3, href: "/productos/chapas-y-perfiles" },
  { name: "Ferreteria", icon: Img4, href: "/productos/ferreteria" },
  { name: "Maderas nacionales e importadas", icon: Img5, href: "/productos/maderas" },
  { name: "Pinturas y Accesorios", icon: Img6, href: "/productos/pinturas-y-accesorios" },
  { name: "Pisos y Decks", icon: Img7, href: "/productos/pisos-y-decks" },
  { name: "Yeso Proyectado", icon: Img12, href: "/productos/yeso" },
]

export default function ProductCategories() {
  return (
    <div style={{ width: '100%' , padding: '0' }}>
      <div className="home-tittles">
        <h3>Productos</h3>
        <hr />
      </div>

      <div className="custom-grid" style={{ marginTop: '60px' }}>
        {categories.map((category) => (
          <a
            key={category.name}
            href={category.href}
            className="product-links-item group"
            style={{ color: '#E73B33' }}
          >
            <div className="div-product-wrapper">
              <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                <img
                  src={category.icon || "/placeholder.svg"}
                  alt={category.name}

                  style={{ color: 'red', width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
            </div>
            <span style={{ textAlign: 'center', color: 'red', fontSize: '14px', fontWeight: '500', textTransform: 'uppercase' }}>{category.name}</span>
          </a>
        ))}
      </div>
    </div>
  )
}